// $FlowFixMe
/* eslint-disable flowtype/no-types-missing-file-annotation */

import * as React from 'react';
import { FaTimes } from 'react-icons/fa';
import { css } from 'glamor';

import { button } from '../../theme/utils';

export const Modal = (
  Body: React.ComponentType<any>,
  Header: React.ComponentType<any>,
  Footer: React.ComponentType<any>,
  formConfig: Object,
  onClose?: Event => void,
) => () => (
  <div className={`overlay ${styles}`}>
    <div className="login-modal">
      <div className="modal-wrapper">
        <div className="modal-content">
          <Header />
          <Body {...formConfig} />
          <Footer {...formConfig} />
        </div>
        {onClose && (
          <button className="close" type="button" onClick={onClose}>
            <FaTimes />
          </button>
        )}
      </div>
    </div>
  </div>
);

const styles = css({
  fontFamily: '\'Qanelas\', sans-serif',
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'rgba(28, 28, 28, 0.45)',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 4000,
  overflow: 'auto',
  ' .login-modal': {
    position: 'relative',
    top: '50%',
    left: 'auto',
    right: 'auto',
    bottom: 'auto',
    transform: 'translate(0%, -50%)',
    border: 'none',
    background: 'rgb(255, 255, 255)',
    overflow: 'auto',
    borderRadius: '1px',
    outline: 'none',
    padding: '25px 30px 35px',
    maxWidth: '100%',
    boxSizing: 'border-box',
    margin: 'auto',
    boxShadow: 'rgba(28, 28, 28, 0.2) 0 0 10px 0, rgba(28, 28, 28, 0.1) 0 2px 4px 0',
    width: '360px',
  },
  ' .modal-wrapper': {
    fontSize: '14px',
    lineHeight: '21px',
    ' .close': {
      ...button,
      color: 'rgb(196, 192, 184)',
      height: '60px',
      width: '60px',
      position: 'absolute',
      top: 0,
      right: 0,
    },
  },
});
